import { Button } from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import { Box, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack5";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router";
import useAuth from "src/hooks/useAuth";
import { decryptData } from "src/utils/decryptcookie";
import { allowOnlyNumeric } from "src/utils/eventUtils";
import { navigateByRole } from "src/utils/roles/roles-condition";

const OTPVerification = () => {
  const navigate = useNavigate();
  const { Otp } = useAuth();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otpResponse, setOtpResponse] = useState({});
  // const LoginData = localStorage.getItem("LoginData");
  // let parsedData = JSON.parse(LoginData);
  const otpInputRefs = [];
  const userDataFromCookie = decryptData("_b60-g6fr_plus"); // userData decrypted here from cookie
  const isOtpVerified = decryptData("_s_t2_ai_token"); // userData decrypted here from cookie
  const { enqueueSnackbar ,closeSnackbar} = useSnackbar();

  const handleOtpChange = (index, event) => {
    const otpValue = event.target.value;
    if (isNaN(otpValue)) {
      return;
    }
    const otpCopy = [...otp];
    otpCopy[index] = otpValue;
    setOtp(otpCopy);
    if (otpValue && otpInputRefs[index + 1]) {
      otpInputRefs[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, event) => {
    
    allowOnlyNumeric(event);
    if (event.key === "Backspace" && !otp[index] && otpInputRefs[index - 1]) {
      otpInputRefs[index - 1].focus();
    }
  };

  const handleOtpPaste = (event) => {
   
    // console.log("pastedData",pastedData)
    event.preventDefault();
    const pastedData = event.clipboardData
      .getData("text/plain")
      .slice(0, 4 - otp.join("").length)
      .split("");
      console.log("pastedData",pastedData)
    const otpCopy = [...otp];
    otpInputRefs.forEach((ref, index) => {
      if (pastedData.length > index) {
        const otpValue = pastedData[index];
        if (!isNaN(otpValue)) {
          otpCopy[index] = otpValue;
        }
      }
    });
    setOtp(otpCopy);
  };

  const verifyOtp = async () => {
    if(otp[otp.length - 1] == ""){
      enqueueSnackbar(`Four digits are required`, {
        variant: "error",
        closereason: "clickaway",
      });
      return 
    } 
    const data = await Otp(
      navigate,
      otp,
      // parsedData?.userid,
      // parsedData?.role,
      userDataFromCookie,
      setOtpResponse
    );
    if (data?.status) {
      enqueueSnackbar(`OTP Verified`, {
        variant: "success",
        onClick: (event, key) => {
          closeSnackbar(key); // Dismiss notification on tap
        }
      });
      // localStorage.setItem("otpVerified", "true");
    } else {
      enqueueSnackbar(`Incorrect OTP`, {
        variant: "error",
        onClick: (event, key) => {
          closeSnackbar(key); // Dismiss notification on tap
        }
      });
    }
  };

  
  useEffect(() => {
    if(otpInputRefs[0]){
      otpInputRefs[0].focus();
    }
  }, []);

  if (isOtpVerified) {
    return <Navigate to={navigateByRole(userDataFromCookie.role)} replace={true} />;
  }

  return (
    <div className="login-pagesite">
      <div className="d-flex">
        <div
          style={{
            maxWidth: 480,
            margin: "auto",
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            justifyContent: "center",
            padding: "12px",
          }}
        >
          <Box sx={{ width: 150 }}>
            <img src="/static/brand/Travomint.png" class="img 2" alt="login" />
          </Box>
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4">Verify OTP</Typography>
              <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
                Please enter OTP received on your Email.
              </Typography>
            </Box>
          </Stack>
          {/* <Button
            onClick={() => localStorage.removeItem("otpVerified")}
          >Delete Local Storage</Button> */}
          <div className="gfrom-login">
            <div className="form-group mt-4">
              <div className={"form-group position-relative ssss"}>
                {otp.map((otpValue, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    required={true}
                    value={otpValue}
                    onChange={(event) => handleOtpChange(index, event)}
                    onKeyDown={(event) => handleOtpKeyDown(index, event)}
                    onPaste={handleOtpPaste}
                    ref={(ref) => (otpInputRefs[index] = ref)}
                  />
                ))}
              </div>
              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={verifyOtp}
                className="mt-4"
                // loading={isSubmitting}
              >
                Submit
              </LoadingButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
